import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative w-full h-full overflow-y-auto max-w-14xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "有反馈或建议，或者想要关注我们的项目进展？快快扫码加群：", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-auto w-60",
  src: "img/wxpr.jpg",
  alt: "QR"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_about_section = _resolveComponent("about-section")!
  const _component_f_skeleton = _resolveComponent("f-skeleton")!
  const _component_change_log = _resolveComponent("change-log")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("span", {
      class: "absolute cursor-pointer top-4 left-4 hover:opacity-80",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routerBack('/user')))
    }, [
      _createVNode(_component_f_icon, {
        name: "back",
        width: 12,
        height: 24
      })
    ]),
    _createVNode(_component_about_section, { title: "联系我们" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_about_section, { title: "更新日志" }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_f_skeleton, {
              key: 0,
              rows: 4
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changeLogs, (log) => {
          return (_openBlock(), _createBlock(_component_change_log, {
            key: log.date,
            "change-log": log
          }, null, 8, ["change-log"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}